import { Subject } from 'rxjs'

// Shared with the storefront shell without loading order services or page components.
export const ebOrderHistoryLoaded$ = new Subject<void>()
